// extracted by mini-css-extract-plugin
export default {"container":"gp-z","bubbleNav":"hp-z","graphic":"ip-z","contact":"jp-z"};